module.exports = __webpack_public_path__ + "7efc3b519479517480764727a73cb386.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/tiyan/tiyan4.jpg
// module id = 1233
// module chunks = 0